package com.xtream.composeapp.presentation.widget

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import kotlinx.browser.window
import org.w3c.dom.events.Event
import org.w3c.dom.events.KeyboardEvent
import kotlin.js.ExperimentalWasmJsInterop

@Composable
actual fun BackHandler(enabled: Boolean, onBack: () -> Unit) {

    DisposableEffect(enabled, onBack) {
        if (!enabled) return@DisposableEffect onDispose {}

        @OptIn(ExperimentalWasmJsInterop::class)
        window.history.pushState(null, "", null)

        val popStateListener: (Event) -> Unit = { onBack() }

        val keyListener: (Event) -> Unit = { event ->
            val keyEvent = event as? KeyboardEvent
            if (keyEvent?.key == "Escape") {
                onBack()
            }
        }

        window.addEventListener("popstate", popStateListener)
        window.addEventListener("keyup", keyListener)  // ← keydown → keyup

        onDispose {
            window.removeEventListener("popstate", popStateListener)
            window.removeEventListener("keyup", keyListener)  // ← keydown → keyup
        }
    }

}